import {memo, useCallback} from 'react'

import type {ProjectOrBuildTypeNode} from '../../../../types'
import {getProjectBuildTypeFilter} from '../../../../types'
import GroupBy from '../../../common/GroupBy/GroupBy'
import MuteStatusFilter from '../../../common/MuteStatusFilter/MuteStatusFilter'
import {ProjectBuildTypeSelect} from '../../../common/ProjectBuildTypeSelect/ProjectBuildTypeSelect'

import {useProjectIdFilter} from './InvestigationFilters.hooks'

import styles from './InvestigationFilters.css'

type Props = {
  withGrouping?: boolean
  withMuteFilter?: boolean
  onChange?: () => void
}

function InvestigationFilters({withGrouping = false, withMuteFilter = false, onChange}: Props) {
  const {projectId, onProjectChange} = useProjectIdFilter()

  const onProjectSelect = useCallback(
    (data: ProjectOrBuildTypeNode | null | undefined) => {
      onProjectChange(data)
      onChange?.()
    },
    [onChange, onProjectChange],
  )

  return (
    <div className={styles.row}>
      <ProjectBuildTypeSelect
        allItemSelectable
        buttonMode
        expandAll
        allItemName="All projects"
        forceFetch={false}
        buildTypesSelectable={false}
        selected={getProjectBuildTypeFilter({projectId})}
        onSelect={onProjectSelect}
      />
      {withGrouping && <GroupBy />}
      {withMuteFilter && <MuteStatusFilter onChange={onChange} />}
    </div>
  )
}

export default memo(InvestigationFilters)
